module.exports = __webpack_public_path__ + "static/media/icon-school-selected.7d0fe948.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-school-selected.svg
// module id = 1612
// module chunks = 0